import styled from 'styled-components';

export const ChartWrapper = styled.div`
	overflow: hidden;
	width: 100%;
`;
